import {Component, ElementRef, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {LoadingService} from './block/interceptor/loading.service';
import {DeviceDetectorService} from "ngx-device-detector";

import 'core-js/es6/string';
import 'core-js/es6/array';
import 'core-js/es6/map';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {JhiEventManager} from "ng-jhipster";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  @ViewChild("template")
  public template: ElementRef;
  modalRef: BsModalRef;
  @Output() eventManager = new JhiEventManager;

  constructor(
    private loadingService: LoadingService,
    private deviceService: DeviceDetectorService,
    private modalService: BsModalService,

  ) {

  }

  ngOnInit() {
    const browser = this.deviceService.getDeviceInfo();
    const version = parseInt(browser.browser_version, 10);

    console.log(browser.browser);
    console.log(browser.browser_version);

    let ok = false;

    if (browser.browser === 'chrome') {
      // ok = version >= 45;
      ok = version >= 45;
    } else if (browser.browser === 'firefox') {
      ok = version >= 38;
    } else if (browser.browser === 'safari') {
      ok = version >= 9;
    } else if (browser.browser === 'opera') {
      ok = version >= 30;
    } else if (browser.browser === 'ie') {
      ok = version >= 10;
    } else if (browser.browser === 'edge') {
      ok = version >= 12;
    }

    if(!ok) {
      this.openModal();
    }
  }

  openModal() {
    this.modalRef = this.modalService.show(this.template, {class: 'modal-sm', backdrop: true, ignoreBackdropClick: true,});
  }

  isLoading() {
    return this.loadingService.isLoading();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts